export default {
  namespaced: true,
  state: {
    showLoading: false,
    loadingDesc: '加载中...'
  },
  getters: {
    showLoading: state => state.showLoading,
    loadingDesc: state => state.loadingDesc
  },
  mutations: {
    showLoading (state, loadingDesc = '加载中...') {
      state.loadingDesc = loadingDesc
      state.showLoading = true
    },
    hideLoading (state) {
      state.showLoading = false
    }
  }
}
